<template>
    <div class="text-center text-red-200 m-4 space-y-3 w-full h-full">
        <Icon name="tabler:alert-triangle" size="48px" />

        <p class="text-body-lg">{{ error }}</p>

        <AppButton
            size="sm"
            class="mx-auto !text-brand-500 rounded-full bg-gray-100 z-50 hover:bg-gray-100"
            @click.stop="tryAgain"
        >
            {{ $t("global_tryAgain") }}
        </AppButton>
    </div>
</template>

<script setup lang="ts">
interface IProps {
    error: any;
}

defineProps<IProps>();

const emits = defineEmits(["reset"]);

const tryAgain = () => {
    emits("reset");
};
</script>

<style scoped></style>
